// ** React Imports
import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Stepper from '@mui/material/Stepper'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import StepLabel from '@mui/material/StepLabel'
import Typography from '@mui/material/Typography'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import MuiStep from '@mui/material/Step'
import InputAdornment from '@mui/material/InputAdornment'
import IgnoreIcon from '@mui/icons-material/VisibilityOff'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardHeader from '@mui/material/CardHeader'
import { DataGrid } from '@mui/x-data-grid'
import { DataGridPro } from '@mui/x-data-grid-pro';
import {TextField, Select, FormControl, InputLabel } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import ListSubheader from '@mui/material/ListSubheader'
import { Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, } from '@mui/material';
import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

// Define the styles for the invalid email cell

// ** Third Party Imports
import axios from 'axios'

// ** Icon Imports
import Icon from '../../../../../components/icon'
import XLSX_Placeholder from "images/Attachment_Icons/XLSX__PlaceholderIcon.png";
import CSV_Placeholder from "images/Attachment_Icons/CSV__PlaceholderIcon.png";

// ** Custom Components Imports
import StepperCustomDot from '../../../../../components/mui/StepperCustomDot'
import CustomTextField from '../../../../../components/mui/text-field'
import CustomChip from '../../../../../components/mui/chip'
import CustomAvatar from '../../../../../components/mui/avatar'
import ServerSideToolbar from '../../../../../components/data-grid/ServerSideToolbar'
// import ServerSideToolbar_WithoutSearch from '../../../../../components/data-grid/ServerSideToolbar_WithoutSearch'

// ** Hook Import
import { useSettings } from '../../../../../components/hooks/useSettings'

// ** Util Import
import { getInitials } from '../../../../../components/utils/get-initials'

// ** Styled Component
import StepperWrapper from '../../../../../components/styles/mui/stepper'

// ** Layout Import
import BlankLayout from '../../../../Layout/blankLayout'
import { stateNames, expandStateName } from 'components/US_StatesNames'
import { dev_baseUrl } from 'utils/var'
import { GetRoles } from 'screens/Settings/logic/GetRoles'

const steps = [
  {
    title: 'Map Columns'
  },
  {
    title: 'Fix Errors'
  }
]

const Step = styled(MuiStep)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  '&:first-of-type': {
    paddingLeft: 0
  },
  '&:last-of-type': {
    paddingRight: 0
  },
  '& .MuiStepLabel-iconContainer': {
    display: 'none'
  },
  '& .step-subtitle': {
    color: `${theme.palette.text.disabled} !important`
  },
  '& + svg': {
    color: theme.palette.text.disabled
  },
  '&.Mui-completed .step-title': {
    color: theme.palette.text.disabled
  },
  '&.Mui-completed + svg': {
    color: theme.palette.primary.main
  },
  [theme.breakpoints.down('md')]: {
    padding: 0,
    ':not(:last-of-type)': {
      marginBottom: theme.spacing(6)
    }
  }
}))

// ** renders client column
const renderClient = params => {
    const { row } = params
    const stateNum = Math.floor(Math.random() * 6)
    const states = ['success', 'error', 'warning', 'info', 'primary', 'secondary']
    const color = states[stateNum]
  }
  
  const statusObj = {
    1: { title: 'current', color: 'primary' },
    2: { title: 'professional', color: 'success' },
    3: { title: 'rejected', color: 'error' },
    4: { title: 'resigned', color: 'warning' },
    5: { title: 'applied', color: 'info' }
  }
const StepEmployeeUploadFile = () => {
  
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (!token) {
      navigate('/login', { state: { message: 'Please login to continue.' } }); // Redirect to login if token is not found
    } else {
      setIsLoading(false); // Set loading to false if token is found
    }
  }, [navigate]);

  const location = useLocation();
  const fileData = location.state?.data || []
  const toEmployees = location.state?.fromDetail || false;

  const columnNamesFromFile = fileData.length > 0 
  ? Object.keys(fileData[0]).filter(columnName => {

      return fileData.some(row => row[columnName] && row[columnName].toString().trim() !== '');
    }) 
  : [];
    

  const predefinedFields = ['First Name', 'Last Name', 'Email', 'Phone','Employee Type','Job Title','Street 1','City', 'State/Province','Zip Code','Role','Departments','Employment Status','Employee Wages Amount','Wage Type'];
  const additionalFields = [
    'Status', 'Date of Birth', 'Referred By', 'Country', 'Emergency Contact Name', 'Emergency Contact Relationship',
    'Emergency Contact Phone Number', 'Hire Date',
    'Probation End Date', 'Driving license','Driving license expiry', 'Availability', 'Clock in / out'
  ];

  const fieldsToRender = [...predefinedFields, ...additionalFields];

  const getDefaultValues = () => {
    const initialValues = {};
    columnNamesFromFile.forEach((columnName) => {
      initialValues[columnName] = fieldsToRender.includes(columnName)
        ? columnName
        : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase())
          ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase())
          : 'select';
    });
    return initialValues;
  };

  const [isMappingConfirmed, setIsMappingConfirmed] = useState(false);
  const [isIgnored, setIsIgnored] = useState(false);

  // ** States
  const [activeStep, setActiveStep] = useState(0)
  const [total, setTotal] = useState(0)
  const [sort, setSort] = useState('asc')
  const [searchValue, setSearchValue] = useState('')
  const [sortColumn, setSortColumn] = useState('first_name')
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 7 })
  const [mappingState, setMappingState] = useState({});
  const [selectedValues, setSelectedValues] = useState(getDefaultValues()); // Track selected dropdown values
  const [errorState, setErrorState] = useState({}); 
  const [myData, setMyData] = useState([]); 
  const [columns, setColumns] = useState([]); 
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(location.state?.message || '');
  const [errorMessages, setErrorMessages] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [openErrorListDlg, setOpenErrorListDlg] = useState(false);
  const [openSuccessListDlg, setOpenSuccessListDlg] = useState(false);
  const [successMessages, setSuccessMessages] = useState('');
  const [alertIsDismissed, setAlertIsDismissed] = useState(false);
  const [showConfirmAlert, setShowConfirmAlert] = useState(true);
  const [displayBanner, setDisplayBanner] = useState(true);
  const [customRoles, setCustomRoles] = useState([]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if(showConfirmAlert){
        e.preventDefault(); 
        e.returnValue = ''; 
      }        
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [showConfirmAlert]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const roles = await GetRoles(0, navigate);
        setCustomRoles(roles || []);
      } catch (error) {
        console.error('Failed to fetch roles:', error);
        setCustomRoles([]);
      }
    };

    fetchRoles();
  }, [navigate]);

  useEffect(() => {
    const fetchDepartments = async () => {
      const token = localStorage.getItem('jwtToken');
      if (!token) {        
        navigate('/login', { state: { message: 'Session expired, please login again.' } });
        return;
      }
  
      try {
        const response = await fetch(`${dev_baseUrl}/Employee/getdepartments`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch departments.");
        }
  
        const result = await response.json();
        
        if (!result.isError) {
          // Updated to match new API structure: { departmentID, department, isActive }
          const mappedDepartments = result.result.map(dep => ({ 
            departmentID: dep.departmentID, 
            department: dep.department,
            isActive: dep.isActive
          }));
          setDepartments(mappedDepartments);
        } else {
          console.error("Error fetching departments:", result.message);
        }
      } catch (error) {
        console.error("Fetch departments error:", error);
      }
    };
  
    fetchDepartments();
  }, [navigate]);
  

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  function loadServerRows(currentPage, data) {
    return data.slice(currentPage * paginationModel.pageSize, (currentPage + 1) * paginationModel.pageSize);
  }

  const fetchTableData = useCallback(
    async (sort, q, column) => {
      let filteredData = [...myData];
  
      if (q) {
        filteredData = filteredData.filter(row =>
          Object.values(row).some(value =>
            value.toString().toLowerCase().includes(q.toLowerCase())
          )
        );
      }
        
      if (sort && column) {
        filteredData = filteredData.sort((a, b) => {
          if (a[column] < b[column]) return sort === 'asc' ? -1 : 1;
          if (a[column] > b[column]) return sort === 'asc' ? 1 : -1;
          return 0;
        });
      }
  
      setTotal(filteredData.length);
      setRows(loadServerRows(paginationModel.page, filteredData));
    },
    [paginationModel.page, paginationModel.pageSize, myData, sort, searchValue, sortColumn]

  );

  useEffect(() => {
    fetchTableData(sort, searchValue, sortColumn)
  }, [fetchTableData, searchValue, sort, sortColumn])

  const handleAlertDismiss = () => {
    setAlertIsDismissed(true);
  }
  
  // Get list of unmapped mandatory fields
  const getUnmappedMandatoryFields = () => {
    return predefinedFields.filter(field => {
      // Check if this field is mapped and confirmed
      const isMapped = Object.values(mappingState).some(
        mapping => mapping.mappedValue === field && mapping.confirmed
      );
      return !isMapped;
    });
  };
  
  const unmappedFields = getUnmappedMandatoryFields();
  const showMandatoryAlert = !alertIsDismissed && unmappedFields.length > 0;

  const handleSortModel = newModel => {
    if (newModel.length) {
      setSort(newModel[0].sort);
      setSortColumn(newModel[0].field);
      fetchTableData(newModel[0].sort, searchValue, newModel[0].field);
    } else {
      setSort('asc');
      setSortColumn(Object.keys(myData[0])[0]); // Sort by the first key in `mappedData`
    }
  };

  const handleSearch = value => {
    setSearchValue(value);
    fetchTableData(sort, value, sortColumn);
  };

  const employeeWagesType = ['Hourly', 'Salary']
  const employeeWagesTypeForSubContractors = ['Per Day', 'Per Job', 'Per Visit']
  const employeeStatusOptions = ['Full Time','Part Time','Contract']
  const statusOptions = ['Active', 'Inactive']
  
  // Use custom roles from API
  const rolesOptions = customRoles.map(role => role.roleName);
  
  // Helper function to find role ID by name
  const findRoleByName = (roleName) => {
    if (!roleName) return null;
    const role = customRoles.find(r => 
      r.roleName?.toLowerCase() === roleName?.toLowerCase()
    );
    return role || null;
  };

  const EmployeeTypeOptions = ['Employees','Sub Contractors']

  // const predefinedFields = ['First Name', 'Last Name', 'Email'];
  // const additionalFields = [
  //   'Phone', 'Role', 'Status', 'Date of Birth', 'Referred By', 'Address', 'City', 'State/Province',
  //   'Postal Code', 'Country', 'Emergency Contact Name', 'Emergency Contact Relationship',
  //   'Emergency Contact Phone Number', 'Hire Date', 'Employment Status', 'Departments',
  //   'Job Title', 'Probation End Date', 'Driving license','Driving license expiry', 'Employee Wages Amount',
  //   'Employee Wages Type', 'Availability', 'Clock in / out'
  // ];

  const stateOptions = stateNames;

  const errorColumns = [
    {
      flex: 0.25,
      minWidth: 180,
      field: 'email',      
      headerName: 'Email'
    },
    {
      flex: 0.25,
      minWidth: 180,      
      headerName: 'Reason',
      field: 'failureReason'
    }       
  ]

  const handleCloseErrorListDlg = () => {
    // sessionStorage.removeItem('myStep');
    // sessionStorage.setItem('myStep', 3);
    setOpenErrorListDlg(false)
    if(toEmployees){
      navigate("/employees")
    } else {
      navigate('/onboarding', { state: { step: 3, skipWelcome: true } });      
    }
    // navigate('/onboarding', { state: { step: 4, skipWelcome: true } });
    // navigate('/onboarding');
  }

  const handleCloseSuccessListDlg = () => {
    // sessionStorage.removeItem('myStep');
    // sessionStorage.setItem('myStep', 4);
    setOpenSuccessListDlg(false);
    if(toEmployees){
      navigate("/employees")
    } else {
      navigate('/onboarding', { state: { step: 3, skipWelcome: true } });      
    }
    // navigate('/onboarding', { state: { step: 4, skipWelcome: true } });
    // handleNext();
    // navigate('/onboarding');
  }

  const excelDateToJSDate = (excelDate) => {
    const serialDate = Number(excelDate); 
    const excelStartDate = new Date(Date.UTC(1900, 0, 1)); 
    const jsDate = new Date(excelStartDate.getTime() + (serialDate - 1) * 24 * 60 * 60 * 1000); 
  
    if (serialDate > 59) {
      jsDate.setUTCDate(jsDate.getUTCDate() - 1);
    }
  
    return jsDate;
  };
  
  // const formatDate = (date) => {
  //   if (isNaN(date.getTime())) {
  //     return 'Invalid Date';
  //   }
  
  //   const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Get month in UTC
  //   const day = String(date.getUTCDate()).padStart(2, '0'); // Get day in UTC
  //   const year = date.getUTCFullYear(); // Get year in UTC
  
  //   return `${month}-${day}-${year}`; // Format as MM-DD-YYYY
  // };

  const parseDateAsUTC = (dateString) => {
    const [month, day, year] = dateString.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day)); // Creates a UTC date
  };
  
  const formatDate = (date) => {
    const jsDate = typeof date === 'string' ? parseDateAsUTC(date) : date;
    
    if (isNaN(jsDate.getTime())) {
      return 'Invalid Date';
    }
  
    const month = String(jsDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(jsDate.getUTCDate()).padStart(2, '0');
    const year = jsDate.getUTCFullYear();
  
    return `${month}-${day}-${year}`;
  };
  
  // ** Hooks & Var
  const { settings } = useSettings()
  const smallScreen = useMediaQuery(theme => theme.breakpoints.down('md'))
  const { direction } = settings


  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
    // const columnNamesFromFile = fileData.length > 0 
    // ? Object.keys(fileData[0]).filter(columnName => {
    //     // Check if this column has any non-empty value across all rows
    //     return fileData.some(row => row[columnName] && row[columnName].toString().trim() !== '');
    //   }) 
    // : [];
  
    // const fieldsToRender = [...predefinedFields, ...additionalFields];
  
    const updateSelectedValues = () => {
      // Create the new selectedValues object based on mappings
      const newSelectedValues = columnNamesFromFile.reduce((acc, columnName) => {
        if (predefinedFields.includes(columnName)) {
          acc[columnName] = selectedValues[columnName] || columnName;
        }
        return acc;
      }, {});
  
      // Update the state with the new object
      setSelectedValues(newSelectedValues);
    };
  
    useEffect(() => {
      updateSelectedValues();
    }, []);
  
  
    // const handleSelectChange = (columnName) => (event) => {
    //   const newValue = event.target.value;
    
    //   setSelectedValues((prev) => {
  
    //     const updatedValues = { ...prev, [columnName]: newValue };
  
    //     // Re-check for conflicts across all columns
    //     const newErrorState = {};
    //     const valueCounts = {};
    
    //     // Count occurrences of each selected value
    //     Object.values(updatedValues).forEach((value) => {
    //       valueCounts[value] = (valueCounts[value] || 0) + 1;
    //     });
    
    //     // Identify conflicts and update the error state
    //     Object.keys(updatedValues).forEach((key) => {
    //       const value = updatedValues[key];
    //       if (valueCounts[value] > 1 ) {
    //         newErrorState[key] = `${value} has already been matched to another column`;
    //       } 
    //     });
  
    //     setErrorState(newErrorState);
    
    //     return updatedValues;
    //   });
    // };
  
    const handleSelectChange = (columnName) => (event) => {
      const newValue = event.target.value;
      
      setSelectedValues((prev) => {
        const updatedValues = { ...prev, [columnName]: newValue };
        
        // Re-check for conflicts across all columns
        const newErrorState = {};
        const valueCounts = {};
        
        // Count occurrences of each selected value (EXCLUDING 'select' and empty values)
        Object.values(updatedValues).forEach((value) => {
          if (value && value !== 'select' && value !== '') {
            valueCounts[value] = (valueCounts[value] || 0) + 1;
          }
        });
        
        // Identify conflicts and update the error state
        Object.keys(updatedValues).forEach((key) => {
          const value = updatedValues[key];
          // Only show error for non-select values that have duplicates
          if (value && value !== 'select' && value !== '' && valueCounts[value] > 1) {
            newErrorState[key] = `${value} has already been matched to another column`;
          }
        });
        
        setErrorState(newErrorState);
        
        return updatedValues;
      });
    };

    const handleConfirmClick = (columnName) => {
  
      const selectedValue = selectedValues[columnName] || (fieldsToRender.includes(columnName) 
      ? columnName 
      : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        : 'select');
    
      if (!selectedValue || selectedValue === 'select') {
        setMessage('Please select a valid field before confirming the mapping.');
        return;
      }
    
      setMappingState((prevState) => ({
        ...prevState,
        [columnName]: {
          ...prevState[columnName],
          confirmed: true,
          ignored: false,
          mappedValue: selectedValue || ''
        }
      }));
    };
    
    // const handleIgnoreClick = (columnName) => (event) => {
    //   setMappingState((prevState) => ({
    //     ...prevState,
    //     [columnName]: {
    //       confirmed: false,
    //       ignored: true,
    //       mappedValue: '' // Clear the mapped value
    //     }
    //   }));
    // };

    // const handleIgnoreClick = (columnName) => {
    //   // Get the current value to check if it was causing a conflict
    //   const currentValue = selectedValues[columnName];
      
    //   setMappingState((prevState) => ({
    //     ...prevState,
    //     [columnName]: {
    //       confirmed: false,
    //       ignored: true,
    //       mappedValue: '' // Clear the mapped value
    //     }
    //   }));
    
    //   // Update selectedValues and errorState in a single batch
    //   setSelectedValues((prev) => {
    //     const updatedValues = { ...prev, [columnName]: 'select' };
        
    //     // After setting to 'select', we need to recalculate error states
    //     const newErrorState = { ...errorState };
        
    //     // Remove error for the ignored column
    //     delete newErrorState[columnName];
        
    //     // Re-check for conflicts among remaining columns (excluding 'select' values)
    //     const valueCounts = {};
        
    //     Object.entries(updatedValues).forEach(([key, value]) => {
    //       if (value && value !== 'select') {
    //         valueCounts[value] = (valueCounts[value] || 0) + 1;
    //       }
    //     });
        
    //     // Check for conflicts again
    //     Object.entries(updatedValues).forEach(([key, value]) => {
    //       if (value && value !== 'select' && valueCounts[value] > 1) {
    //         newErrorState[key] = `${value} has already been matched to another column`;
    //       } else if (value && value !== 'select' && valueCounts[value] <= 1) {
    //         // Remove error if conflict is resolved
    //         delete newErrorState[key];
    //       }
    //     });
        
    //     // Update error state
    //     setErrorState(newErrorState);
        
    //     return updatedValues;
    //   });
    // };
    // const handleIgnoreClick = (columnName) => {
    //   setMappingState((prevState) => ({
    //     ...prevState,
    //     [columnName]: {
    //       confirmed: false,
    //       ignored: true,
    //       mappedValue: '' // Clear the mapped value
    //     }
    //   }));
    
    //   // Set to 'select' and recalculate all errors
    //   setSelectedValues((prev) => {
    //     const updatedValues = { ...prev, [columnName]: 'select' };
        
    //     // Re-check for conflicts across all columns
    //     const newErrorState = {};
    //     const valueCounts = {};
        
    //     // Count occurrences of each selected value (excluding 'select' and empty)
    //     Object.values(updatedValues).forEach((value) => {
    //       if (value && value !== 'select' && value !== '') {
    //         valueCounts[value] = (valueCounts[value] || 0) + 1;
    //       }
    //     });
        
    //     // Identify conflicts and update the error state
    //     Object.keys(updatedValues).forEach((key) => {
    //       const value = updatedValues[key];
    //       // Only show error for non-select values that have duplicates
    //       if (value && value !== 'select' && value !== '' && valueCounts[value] > 1) {
    //         newErrorState[key] = `${value} has already been matched to another column`;
    //       }
    //     });
        
    //     setErrorState(newErrorState);
        
    //     return updatedValues;
    //   });
    // };
    
    const handleEditClick = (columnName) => {
      setMappingState((prevState) => ({
        ...prevState,
        [columnName]: {
          confirmed: false,
          ignored: false,
          mappedValue: '' // Reset the mapping
        }
      }));
    }
  
    // const isConfirmDisabled = (columnName) => {
    //   const selectedValue = selectedValues[columnName] || mappingState[columnName]?.mappedValue || (fieldsToRender.includes(columnName) 
    //   ? columnName 
    //   : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
    //     ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
    //     : 'select');
    //   const hasError = Boolean(
    //     selectedValues[columnName] && Object.values(selectedValues).filter(val => val === selectedValue).length > 1
    //   );
    
    //   // Disable if default value is 'select' or if there is an error for the field
    //   return selectedValue === 'select' || hasError;
    // };

    const isConfirmDisabled = (columnName) => {
      const selectedValue = selectedValues[columnName] || mappingState[columnName]?.mappedValue || (fieldsToRender.includes(columnName) 
      ? columnName 
      : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        : 'select');
      
      // Skip error checking for 'select' values
      if (selectedValue === 'select' || !selectedValue) {
        return true;
      }
      
      const hasError = Boolean(
        selectedValues[columnName] && 
        selectedValues[columnName] !== 'select' &&
        Object.values(selectedValues).filter(val => val === selectedValue && val !== 'select').length > 1
      );
      
      return hasError;
    };

    const handleIgnoreClick = (columnName) => {
      setMappingState((prevState) => ({
        ...prevState,
        [columnName]: {
          confirmed: false,
          ignored: true,
          mappedValue: '' // Clear the mapped value
        }
      }));
    
      // Set to 'select' and recalculate all errors
      setSelectedValues((prev) => {
        const updatedValues = { ...prev, [columnName]: 'select' };
        
        // Re-check for conflicts across all columns
        const newErrorState = {};
        const valueCounts = {};
        
        // Count occurrences of each selected value (excluding 'select' and empty)
        Object.values(updatedValues).forEach((value) => {
          if (value && value !== 'select' && value !== '') {
            valueCounts[value] = (valueCounts[value] || 0) + 1;
          }
        });
        
        // Identify conflicts and update the error state
        Object.keys(updatedValues).forEach((key) => {
          const value = updatedValues[key];
          // Only show error for non-select values that have duplicates
          if (value && value !== 'select' && value !== '' && valueCounts[value] > 1) {
            newErrorState[key] = `${value} has already been matched to another column`;
          }
        });
        
        setErrorState(newErrorState);
        
        return updatedValues;
      });
    };

  const handleBack = () => {
    if (!window.confirm("Are you sure you want to go back? Your changes might not be saved.")) return;
    if (activeStep === 0) {
      // BACK → Connect to Stripe (step 2)
      if(toEmployees){
        navigate('/employees');
      } else {
        navigate('/onboarding', { state: { step: 2, skipWelcome: true } });
      }
      // navigate('/onboarding', { state: { step: 2, skipWelcome: true } });
    } else {
      // internal back: Map Columns ↔ Fix Errors
      if(toEmployees){
        navigate('/employees');
      } else {
        setActiveStep(s => s - 1);
      }
      // setActiveStep(s => s - 1);
    }
  };

  const departmentOptions = departments.map(dep => ({
    departmentID: dep.departmentID,
    department: dep.department,
  }));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      // show only 10 items before scrolling:
      maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP, // 48*10 + 8 = 488px
      width: 250,          // you can adjust width as needed
    },
  },
};

const handleNext = async (event) => {

  setMessage('');
// console.log(event.target?.innerText);
// Move to the next step
if(event.target?.innerText === 'Complete Import'){

const updatedRows = myData.map((row) => {
  const updatedRow = { ...row };
  let hasError = false;

  const invalidNames = [null, '', 'None'];
  if (invalidNames.includes(updatedRow['First Name']) || invalidNames.includes(updatedRow['Last Name'])) {
    hasError = true;
  }

  // Validate email
  if (!validateEmail(updatedRow['Email'])) {
    hasError = true;
  }

  // Check Role
  if (!rolesOptions.includes(updatedRow['Role'])) {
    updatedRow['Role'] = null;
  }

  // Check Employment Status
  if (!employeeStatusOptions.includes(updatedRow['Employment Status'])) {
    updatedRow['Employment Status'] = null;
  }

  if(updatedRow['Employment Status']){
    let es = updatedRow['Employment Status'];
    if (es === 'Full Time') es = 'FullTime';
    else if (es === 'Contract') es = 'Contract';
    else if (es === 'Part Time') es = 'PartTime';
    // Check against valid employment status values
    const validEmploymentStatus = ['FullTime', 'PartTime', 'Contract'];
    updatedRow['Employment Status'] = validEmploymentStatus.includes(es) ? es : null;
  }

  if (!statusOptions.includes(updatedRow['Status'])) {
    updatedRow['Status'] = null;
  }

// Handle Hire Date
if (typeof updatedRow['Hire Date'] === 'string') {
  if (isNaN(Date.parse(updatedRow['Hire Date']))) {
    updatedRow['Hire Date'] = '1900-01-01';
  } else {
    // Parse manually entered date in MM-DD-YYYY as UTC
    const parsedDate = parseDateAsUTC(updatedRow['Hire Date']);
    updatedRow['Hire Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
  }
} else if (!isNaN(updatedRow['Hire Date'])) {
  // Handle Excel serial number dates
  const excelDate = updatedRow['Hire Date'];
  const jsDate = excelDateToJSDate(excelDate);
  updatedRow['Hire Date'] = formatDate(jsDate);
} else {
  // Fallback for Date object or other formats
  const parsedDate = new Date(updatedRow['Hire Date']);
  updatedRow['Hire Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
}


  // Handle Date of Birth
if (typeof updatedRow['Date of Birth'] === 'string') {
  if (isNaN(Date.parse(updatedRow['Date of Birth']))) {
    updatedRow['Date of Birth'] = '1900-01-01';
  } else {
    // Parse manually entered date in MM-DD-YYYY as UTC
    const parsedDate = parseDateAsUTC(updatedRow['Date of Birth']);
    updatedRow['Date of Birth'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
  }
} else if (!isNaN(updatedRow['Date of Birth'])) {
  // Handle Excel serial number dates
  const excelDate = updatedRow['Date of Birth'];
  const jsDate = excelDateToJSDate(excelDate);
  updatedRow['Date of Birth'] = formatDate(jsDate);
} else {
  // Fallback for Date object or other formats
  const parsedDate = new Date(updatedRow['Date of Birth']);
  updatedRow['Date of Birth'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
}

  if (typeof updatedRow['Probation End Date'] === 'string') {
    if (isNaN(Date.parse(updatedRow['Probation End Date']))) {
      updatedRow['Probation End Date'] = '1900-01-01';
    } else {
      // Parse manually entered date in MM-DD-YYYY as UTC
      const parsedDate = parseDateAsUTC(updatedRow['Probation End Date']);
      updatedRow['Probation End Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
    }
  } else if (!isNaN(updatedRow['Probation End Date'])) {
    // Handle Excel serial number dates
    const excelDate = updatedRow['Probation End Date'];
    const jsDate = excelDateToJSDate(excelDate);
    updatedRow['Probation End Date'] = formatDate(jsDate);
  } else {
    // Fallback for Date object or other formats
    const parsedDate = new Date(updatedRow['Probation End Date']);
    updatedRow['Probation End Date'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
  }

if (typeof updatedRow['Driving license expiry'] === 'string') {
  if (isNaN(Date.parse(updatedRow['Driving license expiry']))) {
    updatedRow['Driving license expiry'] = '1900-01-01';
  } else {
    // Parse manually entered date in MM-DD-YYYY as UTC
    const parsedDate = parseDateAsUTC(updatedRow['Driving license expiry']);
    updatedRow['Driving license expiry'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
  }
} else if (!isNaN(updatedRow['Driving license expiry'])) {
  // Handle Excel serial number dates
  const excelDate = updatedRow['Driving license expiry'];
  const jsDate = excelDateToJSDate(excelDate);
  updatedRow['Driving license expiry'] = formatDate(jsDate);
} else {
  // Fallback for Date object or other formats
  const parsedDate = new Date(updatedRow['Driving license expiry']);
  updatedRow['Driving license expiry'] = isNaN(parsedDate.getTime()) ? '1900-01-01' : formatDate(parsedDate);
}

  // Check Driving License
  if (updatedRow['Driving License'] !== 'Valid') {
    updatedRow['Driving License'] = false;
  }

  // Check Employee Wages Type and normalize
  if (updatedRow['Wage Type']) {
    let wt = updatedRow['Wage Type'];
    // Normalize 'Salaried' to 'Salary' to match API expectations
    if (wt === 'Salaried') wt = 'Salary';
    
    // Check if Employee Type is Sub Contractors
    const isSubContractor = updatedRow['Employee Type'] === 'Sub Contractors';
    const validWageTypes = isSubContractor 
      ? [...employeeWagesType, ...employeeWagesTypeForSubContractors]
      : employeeWagesType;
    
    updatedRow['Wage Type'] = validWageTypes.includes(wt) ? wt : null;
  }

  // Check Clock In/Out
  if (updatedRow['Clock in / out'] !== 'Yes') {
    updatedRow['Clock in / out'] = false;
  }

  if(updatedRow['Employee Wages Amount']){
    const raw = updatedRow['Employee Wages Amount'];
    const parsed = parseFloat(raw);
    // If parseFloat produced a valid number (not NaN), keep it; otherwise zero it out
    updatedRow['Employee Wages Amount'] = Number.isFinite(parsed) ? parsed : 0;
  }

  if(updatedRow['Employee Type']){
    let et = updatedRow['Employee Type'];
    if (et === 'Employee') et = 'Employees';
    else if (et === 'Sub Contractor' || et === 'Subcontractor' || et === 'Subcontractors') et = 'Sub Contractors';
    updatedRow['Employee Type'] = EmployeeTypeOptions.includes(et) ? et : null;
  }
    
  if (hasError) return null;

  return updatedRow;
});

// Filter out rows that are null (those with email errors)
const filteredRows = updatedRows.filter((row) => row !== null);

// Create the API payload
const payload = {
  rows: filteredRows,
};

const token = localStorage.getItem('jwtToken');

if (!token) {
  // If there's no token, redirect to login page
  setLoading(true);  
  navigate('/login', { state: { message: 'Session expired, please login again.' } });
  return;
}

// Function to save a new department
const saveDepartment = async (departmentName) => {
  try {
    const requestBody = {
      departmentID: 0,
      department: departmentName,
      isActive: true
    };
    
    const response = await fetch(`${dev_baseUrl}/Employee/saveDepartment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[saveDepartment] Response not OK:", errorText);
      throw new Error(`Failed to save department. Status: ${response.status}`);
    }

    const result = await response.json();
    
    if (!result.isError) {
      return result.result; // Returns the created department with departmentID
    } else {
      console.error("[saveDepartment] API returned error:", result.message);
      return null;
    }
  } catch (error) {
    console.error("[saveDepartment] Exception:", error);
    return null;
  }
};

// Helper function to find or create department
const findOrCreateDepartment = async (departmentValue) => {
  if (!departmentValue) {
    return 0;
  }
  
  // Check if it's a number (departmentID)
  if (!isNaN(departmentValue)) {
    return parseInt(departmentValue);
  }
  
  // Try to find existing department (case-insensitive)
  const matchingDepartment = departmentOptions.find(
    dep => dep.department?.toLowerCase() === departmentValue?.toLowerCase()
  );
  
  if (matchingDepartment) {
    return matchingDepartment.departmentID;
  }
  
  // Department doesn't exist, create it
  const newDepartment = await saveDepartment(departmentValue);
  
  if (newDepartment && newDepartment.departmentID) {
    // Add to local departments list for subsequent rows
    setDepartments(prev => [...prev, {
      departmentID: newDepartment.departmentID,
      department: newDepartment.department,
      isActive: newDepartment.isActive
    }]);
    return newDepartment.departmentID;
  }
  
  return 0; // Fallback if creation failed
};

const isValidDate = (dateString) => {
  // Check if dateString is null, undefined, empty string, 'None', or default date
  if (!dateString || 
      dateString === 'None' || 
      dateString === '1900-01-01' || 
      dateString.toString().trim() === '') return false; 
  const parsedDate = Date.parse(dateString);
  return !isNaN(parsedDate); // Check if it's a valid date
};

const formatDateToYYYYMMDD = (dateString) => {
  const date = parseDateAsUTC(dateString); 

  if (isNaN(date.getTime())) return '1900-01-01';

  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
};

const isValidNANPPhone = (phone) => {

  const hasInvalidCharacters = phone.match(/[^+\d\s\-]/);
  if (hasInvalidCharacters) {
    return false;
  }

  if (phone.startsWith('+') && !phone.startsWith('+1')) {
    return false;
  }

  const countPlus = (phone.match(/\+/g) || []).length;
  if (countPlus > 1) {
    return false;
  }

  const cleanedPhone = phone.replace(/[\+\s\-]/g, ''); // Include hyphens in cleaning

  const normalizedPhone = cleanedPhone.startsWith('1') ? cleanedPhone : `1${cleanedPhone}`;

  if (normalizedPhone.length !== 11) {
    return false;
  }

  const areaCode = normalizedPhone.substring(1, 4);
  if (areaCode[0] === '1') {
    return false;
  }

  return true;
};

const normalizePhoneNumber = (phone) => {
  if (!phone) return null;
  const cleanedPhone = phone.replace(/\D/g, ''); // Remove non-digits
  
  // If it starts with 1 and has 11 digits, remove the country code to get 10 digits
  if (cleanedPhone.startsWith('1') && cleanedPhone.length === 11) {
    return cleanedPhone.substring(1); // Remove the '1' country code
  }
  
  // If it's already 10 digits, return as is
  if (cleanedPhone.length === 10) {
    return cleanedPhone;
  }
  
  // For any other case, return the cleaned phone
  return cleanedPhone;
};

// Process departments first - collect all unique department names that need to be created
// Create a local cache of departments (including newly created ones)
const departmentCache = new Map();

// Initialize cache with existing departments
departmentOptions.forEach(dep => {
  departmentCache.set(dep.department.toLowerCase(), dep.departmentID);
});

const uniqueDepartments = new Set();
payload.rows.forEach((row) => {
  const phoneValue = row['Phone'] ? row['Phone'].toString().trim() : null;
  const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);
  const departmentValue = row['Departments'];
  
  if (!isInvalidPhone) {
    if (departmentValue && isNaN(departmentValue)) {
      const deptKey = departmentValue.toLowerCase();
      if (!departmentCache.has(deptKey)) {
        uniqueDepartments.add(departmentValue);
      }
    }
  }
});

// Create all new departments and update cache
if (uniqueDepartments.size > 0) {
  for (const deptName of uniqueDepartments) {
    const newDepartment = await saveDepartment(deptName);
    
    if (newDepartment && newDepartment.departmentID) {
      const deptKey = deptName.toLowerCase();
      departmentCache.set(deptKey, newDepartment.departmentID);
      
      // Also update state for UI
      setDepartments(prev => [...prev, {
        departmentID: newDepartment.departmentID,
        department: deptName,
        isActive: newDepartment.isActive
      }]);
    }
  }
}

// Now generate the API payload with correct department IDs
const apiPayload = await Promise.all(
  payload.rows
    .filter((row) => {
      const phoneValue = row['Phone'] ? row['Phone'].toString().trim() : null;
      const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);
      return !isInvalidPhone;
    })
    .map(async (row) => {

  const hireDate = row["Hire Date"];
  const dateOfBirth = row['Date of Birth'];
  const probationEndDate = row['Probation End Date'];
  const drivingLicenseExpiry = row['Driving license expiry'];

  // Convert to YYYY-MM-DD format or null if invalid/not provided (matching manual creation)
  const validHireDate = isValidDate(hireDate) ? formatDateToYYYYMMDD(hireDate) : null;
  const validDateOfBirth = isValidDate(dateOfBirth) ? formatDateToYYYYMMDD(dateOfBirth) : null;
  const validProbationEndDate = isValidDate(probationEndDate) ? formatDateToYYYYMMDD(probationEndDate) : null;
  const validDrivingLicenseExpiry = isValidDate(drivingLicenseExpiry) ? formatDateToYYYYMMDD(drivingLicenseExpiry) : null;

  // Get department ID from cache (already created in pre-processing phase)
  let departmentID = 0;
  const departmentValue = row['Departments'];
  
  if (departmentValue) {
    if (!isNaN(departmentValue)) {
      // It's a numeric departmentID
      departmentID = parseInt(departmentValue);
    } else {
      // Look up in cache (case-insensitive)
      const deptKey = departmentValue.toLowerCase();
      departmentID = departmentCache.get(deptKey) || 0;
    }
  }      
    const phoneValue = row['Phone'] ? row['Phone'].toString().trim() : null;
    const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);
    const stateValue = row['State/Province'] || null;
    const expandedState = stateValue ? expandStateName(stateValue) : null;
    const isInvalidState = !stateOptions
      .map(option => option?.toLowerCase()) 
      .includes(stateValue?.toLowerCase()) && 
      !(expandedState && stateOptions
      .map(option => option?.toLowerCase()) 
      .includes(expandedState?.toLowerCase()));

  // Find roleID from role name
  const roleMatch = findRoleByName(row.Role);
  const roleID = roleMatch ? roleMatch.roleID : 0;

  return {
    isActive: true,
    employeeID: 0,
    firstName: row["First Name"] || null,
    lastName: row["Last Name"] || null,
    email: row['Email'] || null,  
    phoneNumbers: [{
      phoneNo: isInvalidPhone ? null : normalizePhoneNumber(phoneValue),
      isPrimary: !isInvalidPhone,
    }],   
    empType: row['Employee Type'],    
    companyID: 0,
    userID: 0,
    roleID: roleID,
    position: row.Role || null,
    title: null,
    dateOfBirth: validDateOfBirth,
    referredBy: row["Referred By"]?.toString() || null,
    address: row["Street 1"]?.toString() || null,
    city: row.City?.toString() || null,
    stateProvince: isInvalidState ? '' : (expandedState || stateValue)?.toString() || null,
    postalCode: row["Zip Code"] ? row["Zip Code"].toString() : null || null,
    country: row.Country?.toString() || null,
    emergencyContactName: row['Emergency Contact Name']?.toString() || null,
    emergencyContactRelationship: row['Emergency Contact Relationship']?.toString() || null,
    emergencyContactPhone: row['Emergency Contact Phone Number']?.toString() || null,
    hireDate: validHireDate,
    employmentStatus: row["Employment Status"]?.toString() || null,
    departmentID: departmentID || 0,
    jobTitle: row['Job Title']?.toString() || null,
    probationEndDate: validProbationEndDate,
    drivingLicenseValid: row['Driving License'] || false,
    drivingLicenseExpiryDate: validDrivingLicenseExpiry,
    wageAmount: row['Employee Wages Amount'] ? parseFloat(row['Employee Wages Amount']) : 0,
    wageType: row['Wage Type']?.toString() || null,
    clockInOutRequired: row['Clock in / out'] || false,
  };
})
);

  setLoading(true);

  try {

    const response = await fetch(`${dev_baseUrl}/Employee/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(apiPayload),            
    });

    if (response.status === 400) {
      // Handle validation error
      const errorResponse = await response.json();
      console.error('Validation Error:', errorResponse);

      // Extract error details
      const validationErrors = errorResponse.errors || {};
      const errorMessages = Object.keys(validationErrors).map((key) => {
        const errorList = validationErrors[key].join(', ');
        return `${key}: ${errorList}`;
      });

      // setErrorDetails(errorMessages);
      setMessage('Validation errors occurred. Please check your input.');
      return;
    }

    if (response.status === 401) {
      // Token is invalid or expired, redirect to login
      navigate('/login', { state: { message: 'Session expired, please login again.' } });
      return;
    }
    
    if (!response.ok) {
      const errorMessage = `Error ${response.status}: ${response.statusText}`;
      console.error(errorMessage);
      setMessage('Failed to save employee data. Please try again.');
    }

    const result = await response.json();
    // console.log("API Response:", result);

    if (result.isError) {
      const failureMessages = result.result
            .filter(item => item.failureReason) 
            .map(item => `${item.firstName} ${item.lastName}: ${item.failureReason}`); 

        if (failureMessages.length > 0) {
          const errorMessagesWithIds = result.result.map((row, index) => ({
            ...row,
            id: index, 
          }));
        
          setErrorMessages(errorMessagesWithIds);
          setOpenErrorListDlg(true); 
          return;
            
        }
      
    } else {
      // sessionStorage.setItem('myStep', 3);
      setSuccessMessages((result?.message && result?.message === "All employees saved successfully." ? 'Valid employees imported successfully.' : result?.message ) || 'Valid employees imported successfully.');
      setOpenSuccessListDlg(true);
    }

  } catch (error) {
    console.error("Error:", error);
    setMessage('An error occurred while importing data. Please try again.');
  } finally {
    setLoading(false); 
  }

} else {
  
  const handleDepartmentChange = (event, params) => {
    const value = event.target.value;
    const selectedDepartment = departmentOptions.find(dep => dep.value === value);
  
    if (selectedDepartment) {
      // Update cell value with department key
      params.api.setEditCellValue({ id: params.id, field: 'Department', value: selectedDepartment.key }, event);
    } else {
      console.error("Selected department is invalid.");
    }
  
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === params.id ? { ...row, departmentID: selectedDepartment?.key || null } : row
      )
    );
  };

  const allMappedOrIgnored = columnNamesFromFile.every(
      (columnName) => mappingState[columnName]?.confirmed || mappingState[columnName]?.ignored
    );
    
    if (!allMappedOrIgnored) {
      setMessage('Please confirm mapping or ignore all columns before continuing.');
      return;
    }

    const requiredFields = ['First Name', 'Last Name', 'Email', 'Phone','Employee Type','Job Title','Street 1','City', 'State/Province','Zip Code','Role','Departments','Employment Status','Employee Wages Amount','Wage Type'];
    const isMappingComplete = requiredFields.every(field =>
      Object.values(mappingState).some(mapping => mapping.mappedValue === field && mapping.confirmed)
    );

    if (!isMappingComplete) {
      setMessage('Please map all the required fields: First Name, Last Name, Email, Phone, Employee Type, Job Title, Street 1, City, State/Province, Zip Code, Role, Departments, Employment Status, Employee Wages Amount, and Wage Type before proceeding.');
      return;
    }

    const mappedData = fileData.map((row, rowIndex) => {
      const mappedRow = {};

      const isRowEmpty = Object.values(row).every((value) => !value);
      if (isRowEmpty) {
        return null; // Skip empty rows
      }
    
      for (const columnName in row) {
        if (mappingState[columnName]?.confirmed) {
          const mappedField = mappingState[columnName].mappedValue;
          mappedRow[mappedField] = row[columnName];
        }
      }
    
      return { id: rowIndex.toString(), ...mappedRow };
    }).filter(row => row !== null); // Filter out null rows

    setMyData(mappedData);
  
// ===========================================================

const Rows = mappedData.map((row, index) => ({
  id: index.toString(),
  ...row,
}));
  
setRows(Rows);
setPaginationModel({ page: 0, pageSize: Rows.length })

const columns = Object.keys(mappedData[0] || {}).map(key => {
  
  if (key === 'Employee Type') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderHeader: () => (
        <Tooltip title="Employee Type is either Employee or Subcontractor" arrow>
          <strong>Employee Type</strong>
        </Tooltip>
      ),
      renderEditCell: (params) => (
        <Select
          value={params.value || ''} 
          onChange={(event) => {
            const value = event.target.value;
          
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            // Get current row data to check if wage type needs to be cleared
            const currentRow = myData.find(row => row.id === params.id);
            const currentWageType = currentRow?.['Wage Type'];
            
            // Determine if current wage type is valid for the new employee type
            const isSubContractor = value === 'Sub Contractors';
            const validWageTypes = isSubContractor 
              ? [...employeeWagesType, ...employeeWagesTypeForSubContractors]
              : employeeWagesType;
            
            // Clear wage type if it's not valid for the new employee type
            const shouldClearWageType = currentWageType && !validWageTypes.includes(currentWageType);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id 
                  ? { 
                      ...row, 
                      [key]: value,
                      ...(shouldClearWageType && { 'Wage Type': '', 'Employee Wages Amount': 0 })
                    } 
                  : row
              )
            );

            // Update rows state directly here
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id 
                  ? { 
                      ...row, 
                      [key]: value,
                      ...(shouldClearWageType && { 'Wage Type': '', 'Employee Wages Amount': 0 })
                    } 
                  : row
              )
            );
            
            // Also update the wage type cell if needed
            if (shouldClearWageType) {
              params.api.setEditCellValue({ id: params.id, field: 'Wage Type', value: '' }, event);
            }
          }}
          renderValue={(selected) => selected || 'None'} 
          sx={{
            m:0,
            p: 0
          }}
        >
          {EmployeeTypeOptions.map(role => (
            <MenuItem key={role} value={role}>
              <ListItemText primary={role} />
            </MenuItem>
          ))}
          <MenuItem key="none" value="">
            <ListItemText primary="None" />
          </MenuItem>
        </Select>
      ),
      renderCell: (params) => {
        // const isValidRole = EmployeeTypeOptions.includes(params.value);
        const raw = params.value;
        const normalized = raw === 'Employee'
          ? 'Employees'
          : (raw === 'Sub Contractor' || raw === 'Subcontractor' || raw === 'Subcontractors')
            ? 'Sub Contractors'
            : raw;
        const isValidRole = EmployeeTypeOptions.includes(normalized);
        const displayValue = isValidRole ? params.value : 'None';
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidRole ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidRole ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={isValidRole ? '' : `${params.value} is not a valid value. Please select valid value from dropdown`}
                placement="bottom"
                arrow
              >
                <Typography variant="body2">
                  {displayValue}
                </Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    };
  } else if (key === 'Role') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <Select
          value={params.value || ''} 
          onChange={(event) => {
            const value = event.target.value;
          
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update rows state directly here
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          renderValue={(selected) => selected || 'None'} 
          sx={{
            m:0,
            p: 0
          }}
        >
          {rolesOptions.map(role => (
            <MenuItem key={role} value={role}>
              <ListItemText primary={role} />
            </MenuItem>
          ))}
          <MenuItem key="none" value="">
            <ListItemText primary="None" />
          </MenuItem>
        </Select>
      ),
      renderCell: (params) => {
        const matchedRole = findRoleByName(params.value);
        const isValidRole = !!matchedRole;
        const displayValue = isValidRole ? params.value : 'None';
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidRole ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidRole ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={isValidRole ? '' : 'Role not found. Please select from dropdown.'}
                placement="bottom"
                arrow
              >
                <Typography variant="body2">
                  {displayValue}
                </Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    };
  } else if (key === 'Employment Status') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <Select
          value={params.value || ''} 
          onChange={(event) => {
            const value = event.target.value;
          
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update rows state directly here
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          renderValue={(selected) => selected || 'None'} 
          sx={{
            m:0,
            p: 0
          }}
        >
          {employeeStatusOptions.map(status => (
            <MenuItem key={status} value={status}>
              <ListItemText primary={status} />
            </MenuItem>
          ))}
          <MenuItem key="none" value="">
            <ListItemText primary="None" />
          </MenuItem>
        </Select>
      ),
      renderCell: (params) => {
        const isValidStatus = employeeStatusOptions.includes(params.value);
        const displayValue = isValidStatus ? params.value : 'None';
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidStatus ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidStatus ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={isValidStatus ? '' : `${params.value} is not a valid value. Please select valid value from dropdown`}
                placement="bottom"
                arrow
              >
                <Typography variant="body2">
                  {displayValue}
                </Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    };
  } else if (key === 'Departments') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <Select
          // Ensure the dropdown shows the department name by finding it using the departmentID
          value={
            departments.find(dep => dep.departmentID === params.value)?.department || 
            departments.find(dep => dep.department === params.value)?.department || ''
          }
          onChange={(event) => {
            const selectedValue = event.target.value;
            const selectedDepartment = departments.find(dep => dep.department === selectedValue);
            const departmentName = selectedDepartment ? selectedDepartment.department : selectedValue;
  
            // Set the department name as the value in the DataGrid cell
            params.api.setEditCellValue({ id: params.id, field: key, value: departmentName }, event);
            
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, Departments: departmentName } : row
              )
            );

            // Update the rows state with the department name
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, Departments: departmentName } : row
              )
            );
          }}
          renderValue={(selected) => selected || 'None'} // Show 'None' if no selection
        >
          {departments.map(option => (
            <MenuItem key={option.departmentID} value={option.department}>
              <ListItemText primary={option.department} />
            </MenuItem>
          ))}
          <MenuItem key="none" value="">
            <ListItemText primary="None" />
          </MenuItem>
        </Select>
      ),
      
      renderCell: (params) => {
        // Match by department name or departmentID
        const department = departments.find(
          dep => dep.department?.toLowerCase() === params.value?.toLowerCase() || 
                 dep.departmentID === params.value
        );
  
        // Department is valid if it exists OR if it's a new department name (will be created)
        const isValidDepartment = !!department || (params.value && typeof params.value === 'string');
  
        // Show the department name if valid, otherwise show "None"
        const displayDepartmentValue = department ? department.department : (params.value || 'None');
        
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidDepartment ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidDepartment ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={
                  department ? '' : 
                  (params.value && typeof params.value === 'string') ? 
                  `New department "${params.value}" will be created automatically.` : 
                  'Please select or enter a department name.'
                }
                placement="bottom"
                arrow
              >
                <Typography variant="body2">{displayDepartmentValue}</Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    };
  } else if (key === 'Status') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <Select
          value={params.value || ''} // Ensure value is a string
          onChange={(event) => {
            const value = event.target.value;
            // Use params.api.setEditCellValue to update the cell value
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update rows state directly here
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          renderValue={(selected) => selected || 'None'} // Show 'None' if no selection
        >
          {statusOptions.map(status => (
            <MenuItem key={status} value={status}>
              <ListItemText primary={status} />
            </MenuItem>
          ))}
          <MenuItem key="none" value="">
            <ListItemText primary="None" />
          </MenuItem>
        </Select>
      ),
      renderCell: (params) => {
        const isValidStatus = statusOptions.includes(params.value);
        const displayStatusValue = isValidStatus ? params.value : 'None';
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidStatus ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidStatus ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={isValidStatus ? '' : `${params.value} is not a valid value. Please select valid value from dropdown`}
                placement="bottom"
                arrow
              >
                <Typography variant="body2">
                  {displayStatusValue}
                </Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    };
  } else if (key === 'State/Province') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <Select
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
  
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );            
  
          }}
          renderValue={(selected) => selected || 'None'} 
          MenuProps={MenuProps}  
        >
          {stateOptions.map(state => (
            <MenuItem key={state} value={state}>
              <ListItemText primary={state} />
            </MenuItem>
          ))}
          <MenuItem key="none" value="">
            <ListItemText primary="None" />
          </MenuItem>
        </Select>
      ),
      renderCell: (params) => {
        params.value = params?.value?.toString();
        
        const expandedState = params.value ? expandStateName(params.value) : null;
        const isValidState = stateOptions
          .map(option => option?.toLowerCase()) 
          .includes(params.value?.toLowerCase()) || 
          (expandedState && stateOptions
          .map(option => option?.toLowerCase()) 
          .includes(expandedState?.toLowerCase())); 
          
        const displayValue = isValidState ? params.value : 'None';
  
        return (
          <Box
            sx={{
              backgroundColor: isValidState ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: '8px',
              borderRadius: '4px',
              position: 'relative',
            }}
          >
            <Tooltip
              title={isValidState ? '' : `${params.value} is not a valid value. Please select a valid value from the dropdown or this value will be skipped`}
              placement="bottom"
              arrow
            >
              <Typography variant="body2">
                {displayValue}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    };
  } else if (key === 'Email') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
  
            // Update the grid's internal state immediately
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            // Perform validation for the email
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state directly, regardless of validation
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
  
            // Optionally, log or handle the invalid email scenario 
            if (!isValidEmail && value !== '') {
              console.warn('Invalid email format');
            }
          }}
          variant="outlined"
          error={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value) && params.value !== ''}
          helperText={
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value) && params.value !== ''
              ? 'Invalid email format'
              : ''
          }
        />
      ),
      renderCell: (params) => {
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value);
        params.value = params.value.length === 0 ? 'none' : params.value;
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidEmail ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidEmail ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={
                  !isValidEmail
                    ? 'You can start your import, but this employee will be skipped. Try putting it in name@example.com'
                    : ''
                }
                placement="bottom"
                arrow
              >
                <Typography variant="body2">{params.value}</Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    };
  } else if (key === 'Phone') {

    const isValidNANPPhone = (phone) => {
      const hasInvalidCharacters = phone.match(/[^+\d\s\-]/);
      if (hasInvalidCharacters) {
        return false;
      }
    
      if (phone.startsWith('+') && !phone.startsWith('+1')) {
        return false;
      }
    
      const countPlus = (phone.match(/\+/g) || []).length;
      if (countPlus > 1) {
        return false;
      }
    
      const cleanedPhone = phone.replace(/[\+\s\-]/g, '');
      const normalizedPhone = cleanedPhone.startsWith('1') ? cleanedPhone : `1${cleanedPhone}`;
    
      if (normalizedPhone.length !== 11) {
        return false;
      }
    
      const areaCode = normalizedPhone.substring(1, 4);
      if (areaCode[0] === '1') {
        return false;
      }
      
      return true;
    };
    
    return {
        field: key,
        headerName: 'Phone',
        flex: 1,
        minWidth: 150,
        editable: true,
        renderEditCell: (params) => {
            return (
                <TextField
                    value={params.value || ''}
                    onChange={(event) => {
                        const value = event.target.value;
  
                        params.api.setEditCellValue({ id: params.id, field: key, value }, event);
                        
                        setMyData((prevData) =>
                          prevData.map((row) =>
                            row.id === params.id ? { ...row, [key]: value } : row
                          )
                        );
  
                        // Update rows state
                        setRows((prevRows) =>
                            prevRows.map((row) =>
                                row.id === params.id ? { ...row, [key]: value } : row
                            )
                        );                      
                    }}
                    
                />
            );
        },
        renderCell: (params) => {
          const phoneValue = params.value ? String(params.value) : '';
          const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);

            return (
                <Box
                    sx={{
                        backgroundColor: isInvalidPhone ? 'rgba(227, 0, 0, 0.1)' : 'transparent',
                        padding: '9px',
                        borderRadius: '4px',
                        position: 'relative',
                    }}
                >
                    <Tooltip
                        title={isInvalidPhone ? 'This employee will be skipped. Invalid phone number.' : ''}
                        placement="bottom"
                        arrow
                    >
                        <Typography variant="body2">
                            {params.value || 'None'}
                        </Typography>
                    </Tooltip>
                </Box>
            );
        },
    };
  } else if (key === 'First Name') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
  
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            // Perform validation for the name
            const isValidName = value && value.length > 1 && value !=='None';
            
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state directly, regardless of validation
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            ); 

            if (!isValidName && value !== '') {
              console.warn('Invalid name');
            }
          }}
          variant="outlined"
          error={params.value !== ''}
          helperText={
            params.value !== ''
              ? 'Invalid name'
              : ''
          }
        />
      ),
      renderCell: (params) => {
        const isValidName = params.value && params.value.length > 1 && params.value !== 'None';
        params.value = params.value.length === 0 ? 'None' : params.value;
        return (
          <Box
            sx={{
              backgroundColor: isValidName ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: '9px',
              borderRadius: '4px',
              position: 'relative',
            }}
          >
            <Tooltip
              title={
                isValidName
                  ? ''
                  : 'You can start your import, but this employee will be skipped. Try putting it a valid name'
              }
              placement="bottom"
              arrow
            >
              <Typography variant="body2">{params.value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    };
  } else if (key === 'Last Name') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
  
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            // Perform validation for the name
            const isValidName = value && value.length > 1 && value !=='None';
            
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state directly, regardless of validation
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
            
            if (!isValidName && value !== '') {
              console.warn('Invalid name');
            }
          }}
          variant="outlined"
          error={params.value !== ''}
          helperText={
            params.value !== ''
              ? 'Invalid name'
              : ''
          }
        />
      ),
      renderCell: (params) => {
        const isValidName = params.value && params.value.length > 1 && params.value !== 'None';
        params.value = params.value.length === 0 ? 'None' : params.value;
        return (
          <Box
            sx={{
              backgroundColor: isValidName ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: '9px',
              borderRadius: '4px',
              position: 'relative',
            }}
          >
            <Tooltip
              title={
                isValidName
                  ? ''
                  : 'You can start your import, but this employee will be skipped. Try putting it a valid name'
              }
              placement="bottom"
              arrow
            >
              <Typography variant="body2">{params.value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    };
  } else if (key === 'Hire Date') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;

            // Update the grid's internal state
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          placeholder="MM-DD-YYYY"
          variant="outlined"
          error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
          helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
        />
      ),
      renderCell: (params) => {
        const excelDate = params.value;
        const isNumber = !isNaN(excelDate);
        const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
        const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
      
        // Date validation (MM-DD-YYYY format)
        const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
      
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidDate ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={
                  isValidDate
                    ? ''
                    : 'Invalid date format. Please use format MM-DD-YYYY.'
                }
                placement="bottom"
                arrow
              >
                <Typography variant="body2">{displayDate}</Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },      
    };
  } else if (key === 'Date of Birth') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;

            // Update the grid's internal state
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          placeholder="MM-DD-YYYY"
          variant="outlined"
          error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
          helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
        />
      ),
      renderCell: (params) => {
        const excelDate = params.value;
        const isNumber = !isNaN(excelDate);
        const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
        const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
      
        // Date validation (MM-DD-YYYY format)
        const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
      
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidDate ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={
                  isValidDate
                    ? ''
                    : 'Invalid date format. Please use format MM-DD-YYYY.'
                }
                placement="bottom"
                arrow
              >
                <Typography variant="body2">{displayDate}</Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },      
    };
  } else if (key === 'Probation End Date') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;

            // Update the grid's internal state
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          placeholder="MM-DD-YYYY"
          variant="outlined"
          error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
          helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
        />
      ),
      renderCell: (params) => {
        const excelDate = params.value;
        const isNumber = !isNaN(excelDate);
        const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
        const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
      
        // Date validation (MM-DD-YYYY format)
        const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
      
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidDate ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={
                  isValidDate
                    ? ''
                    : 'Invalid date format. Please use format MM-DD-YYYY.'
                }
                placement="bottom"
                arrow
              >
                <Typography variant="body2">{displayDate}</Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },      
    };
  } else if (key === 'Driving license expiry') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;

            // Update the grid's internal state
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          placeholder="MM-DD-YYYY"
          variant="outlined"
          error={!/^\d{2}-\d{2}-\d{4}$/.test(params.value)}
          helperText={!/^\d{2}-\d{2}-\d{4}$/.test(params.value) ? 'Invalid date format' : ''}
        />
      ),
      renderCell: (params) => {
        const excelDate = params.value;
        const isNumber = !isNaN(excelDate);
        const jsDate = isNumber ? excelDateToJSDate(excelDate) : parseDateAsUTC(excelDate); // Convert if it's a number
        const displayDate = formatDate(jsDate); // Format to MM-DD-YYYY
      
        // Date validation (MM-DD-YYYY format)
        const isValidDate = /^\d{2}-\d{2}-\d{4}$/.test(displayDate);
      
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidDate ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidDate ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={
                  isValidDate
                    ? ''
                    : 'Invalid date format. Please use format MM-DD-YYYY.'
                }
                placement="bottom"
                arrow
              >
                <Typography variant="body2">{displayDate}</Typography>
              </Tooltip>
            </Box>
          </Box>
        );
      },      
    };
  } else if (key === 'Wage Type') {
    return {
      field: key,
      headerName: 'Wage Type',
      flex: 1,
      minWidth: 150,
      editable: true,
      renderEditCell: (params) => {
        // Get the Employee Type for this row - check myData for latest value
        const currentRowData = myData.find(row => row.id === params.id);
        const employeeType = currentRowData?.['Employee Type'] || params.row?.['Employee Type'];
        const isSubContractor = employeeType === 'Sub Contractors';
        
        return (
          <Select
            value={params.value || ''}
            onChange={(event) => {
              const value = event.target.value;
              
              // Get the latest Employee Type from myData state
              const latestRowData = myData.find(row => row.id === params.id);
              const currentEmployeeType = latestRowData?.['Employee Type'] || params.row?.['Employee Type'];
              const currentIsSubContractor = currentEmployeeType === 'Sub Contractors';
              
              const validOptions = currentIsSubContractor 
                ? [...employeeWagesType, ...employeeWagesTypeForSubContractors]
                : employeeWagesType;
              
              const isValid = validOptions.includes(value);

              if (!isValid && value !== '') {
                console.log('Validation failed:', {
                  value,
                  currentEmployeeType,
                  currentIsSubContractor,
                  validOptions,
                  isValid
                });
                return; // Do not update invalid value
              }
    
              // Update Employee Wages Type
              params.api.setEditCellValue({ id: params.id, field: key, value }, event);
    
              setMyData((prevData) =>
                prevData.map((row) =>
                  row.id === params.id
                    ? { ...row, [key]: value, 'Employee Wages Amount': 0 }
                    : row
                )
              );
    
              // Update rows state
              setRows((prevRows) =>
                prevRows.map((row) =>
                  row.id === params.id
                    ? { ...row, [key]: value, 'Employee Wages Amount': 0 }
                    : row
                )
              );
            }}
            renderValue={(selected) => selected || 'None'}
            sx={{ m: 0, p: 0 }}
          >
            <MenuItem value="Salary">
              <ListItemText primary="Salary" />
            </MenuItem>
            <MenuItem value="Hourly">
              <ListItemText primary="Hourly" />
            </MenuItem>
            {isSubContractor && (
              <MenuItem value="Per Day">
                <ListItemText primary="Per Day" />
              </MenuItem>
            )}
            {isSubContractor && (
              <MenuItem value="Per Job">
                <ListItemText primary="Per Job" />
              </MenuItem>
            )}
            {isSubContractor && (
              <MenuItem value="Per Visit">
                <ListItemText primary="Per Visit" />
              </MenuItem>
            )}
            <MenuItem key="none" value="">
              <ListItemText primary="None" />
            </MenuItem>
          </Select>
        );
      },
      renderCell: (params) => {
        // Get the Employee Type for this row - check myData for latest value
        const currentRowData = myData.find(row => row.id === params.id);
        const employeeType = currentRowData?.['Employee Type'] || params.row?.['Employee Type'];
        const isSubContractor = employeeType === 'Sub Contractors';
        
        // Determine valid options based on Employee Type
        const validOptions = isSubContractor 
          ? [...employeeWagesType, ...employeeWagesTypeForSubContractors]
          : employeeWagesType;

        const isValidStatus = validOptions.includes(params.value);
        const displayStatusValue = isValidStatus ? params.value : 'None';

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
            }}
          >
            <Box sx={{
              backgroundColor: isValidStatus ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: isValidStatus ? '0px' : '8px',
              borderRadius: '4px',
              width: '100%'
            }}>
              <Tooltip
                title={
                  isValidStatus
                    ? ''
                    : `${params.value} is not a valid value. Please select a valid value from the dropdown.`
                }
                placement="bottom"
                arrow
              >
                <Typography variant="body2">{displayStatusValue}</Typography>
              </Tooltip>
            </Box>
          </Box>
      )
    },
    };
  } else if (key === 'Employee Wages Amount') {
    return {
      field: key,
      headerName: 'Employee Wages Amount',
      flex: 1,
      minWidth: 150,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          type="number"
          onChange={(event) => {
            const value = Number(event.target.value);
  
            // Update Employee Wages Amount
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
  
            // Update rows state
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          variant="outlined"
        />
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            width: '100%',
          }}
        >
          <Typography variant="body2">
            {params.value || '0'}
          </Typography>
        </Box>
      ),
    };
  } else {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
            
            // Update the grid's internal state
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
          }}
          variant="outlined"
        />
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: 'flex',
              alignItems: 'center',
              position: 'relative',
              height: '100%',
              width: '100%'
          }}
        >
          <Box sx={{
              backgroundColor: 'transparent',
              padding: '0px',
              borderRadius: '4px',
              width: '100%'
            }}>
            <Typography variant="body2" sx={{ color: 'text.primary' }}>
              {params.value}
            </Typography>
            </Box>
        </Box>
      ),
    };
  }
});


const filteredColumns = columns.filter(column => column.field !== 'id');
setColumns(filteredColumns);

// ===========================================================

setActiveStep((prevActiveStep) => prevActiveStep + 1);

 }

};

const [alignment, setAlignment] = useState('all')

// helper for phone validity (same rules you already use)
const isValidPhone = (phone = '') => {
  const hasBadChars = phone.match(/[^+\d\s\-]/)
  if (hasBadChars) return false
  if (phone.startsWith('+') && !phone.startsWith('+1')) return false
  if ((phone.match(/\+/g) || []).length > 1) return false
  const cleaned = phone.replace(/[\+\s\-]/g, '')
  const norm = cleaned.startsWith('1') ? cleaned : `1${cleaned}`
  if (norm.length !== 11) return false
  if (norm[1] === '1') return false
  return true
}

// build your three buckets
const isValidDate = value => {
  if (value == null || value === '') return false;

  // 1) Excel serial date (a pure number)
  if (typeof value === 'number') {
    const jsDate = excelDateToJSDate(value);
    return !isNaN(jsDate.getTime());
  }

  // 2) “MM/DD/YYYY” or “MM-DD-YYYY”
  //    Normalize to slashes, then split
  const parts = value.replace(/-/g, '/').split('/');
  if (parts.length === 3) {
    const [mm, dd, yyyy] = parts.map(x => parseInt(x, 10));
    if (
      String(mm).length > 0 &&
      String(dd).length > 0 &&
      String(yyyy).length === 4
    ) {
      const d = new Date(yyyy, mm - 1, dd);
      return (
        d.getFullYear() === yyyy &&
        d.getMonth() === mm - 1 &&
        d.getDate() === dd
      );
    }
  }

  // 3) Fallback: let Date.parse handle anything else
  return !isNaN(Date.parse(value));
};

const allRows = rows

function isRowCompletelyValid(row) {
  if (!validateEmail(row.Email))                           return false
  if (!isValidPhone(String(row.Phone||'')))                return false
  if (!row['First Name']?.trim() || !row['Last Name']?.trim()) return false
  // if (!rolesOptions.includes(row.Role))                    return false
  // if (!employeeStatusOptions.includes(row['Employment Status'])) return false
  // if (!statusOptions.includes(row.Status))                 return false
  // if (!isValidDate(row['Date of Birth']))                  return false
  // if (!isValidDate(row['Hire Date']))                       return false
  // if (!isValidDate(row['Probation End Date']))             return false
  // if (!isValidDate(row['Driving license expiry']))         return false
  // if (!employeeWagesType.includes(row['Employee Wages Type'])) return false
  // etc… check any other dropdown / boolean / numeric cell you have
  return true
}

const validRows   = allRows.filter(isRowCompletelyValid)
const invalidRows = allRows.filter(r => !isRowCompletelyValid(r))


// const validRows = allRows.filter(row => {
//   const emailOk = validateEmail(row.Email)
//   const phoneOk = isValidPhone(String(row.Phone || ''))
//   const namesOk = Boolean(row['First Name']?.trim() && row['Last Name']?.trim())
//   return emailOk && phoneOk && namesOk
// })

// const invalidRows = allRows.filter(r => !validRows.includes(r))

// choose which to show
const displayRows = alignment === 'all'
  ? allRows
  : alignment === 'valid'
    ? validRows
    : invalidRows

const handleAlignment = (event, newAlignment) => {
  if (newAlignment !== null) {
    setAlignment(newAlignment)
  }
}

  const getStepContent = step => {
    switch (step) {
      case 0:
        return (
          <Fragment>
            <Grid container spacing={5}
               //sx={{mt: 1}}
               >
               {/* {displayBanner && (
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    backgroundColor: "rgb(35, 162, 109, 0.1)",
                                    border: "1px solid",
                                    borderColor: "success.main",
                                    borderRadius: "12px",
                                    py: 1,
                                    px: 3,
                                    gap: 1,
                                  }}
                                >
                                  <Icon icon="tabler:info-circle" />
                                  <Typography
                                    variant="h6"
                                    fontWeight="500"
                                    sx={{ ml: 2, mr: 3 }}
                                  >
                                    These fields are editable! -You can use your AI Assistant
                                    to do this part later.
                                  </Typography>
                                
                                    <IconButton onClick={() => setDisplayBanner(false)}>
                                      <Icon icon="tabler:x" />
                                    </IconButton>
                                  
                                </Box>
                              </Grid>
                            )} */}
              { showMandatoryAlert && (
                <Grid item xs={12}>
                  <Box sx=
                    {{
                      display: 'inline-flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 159, 67, 0.16)',
                      border: '1px solid', 
                      borderColor: 'warning.main', 
                      borderRadius: '12px', 
                      py: 1,
                      px: 3,
                      gap: 2
                    }}>
                    <Icon icon="tabler:alert-triangle" />
                    <Typography variant='h6' fontWeight='500'>
                      Please ensure the {unmappedFields.join(', ').replace(/,([^,]*)$/, ' and$1')} {unmappedFields.length === 1 ? 'field is' : 'fields are'} mapped as {unmappedFields.length === 1 ? "it's" : "they are"} required to proceed with the next steps.
                    </Typography>
                    <IconButton onClick={handleAlertDismiss} color='warning'>
                      <Icon icon='tabler:x' />
                    </IconButton>
                  </Box>
                </Grid>
              ) }
              <Grid item xs={12} sm={4}>
                <Typography variant="h5" color='text.secondary' fontWeight='550' gutterBottom>File Source Fields</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
              <Typography variant="h5" color='text.secondary' fontWeight='550' gutterBottom>Cleri Fields</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                {/* Empty grid to align the third column (status buttons) */}
              </Grid>
            
              {/* Dropdowns Row */}
              {columnNamesFromFile.map((columnName, colIndex) => (
                <Fragment key={colIndex}>
                  <Grid item xs={12} sm={4}>
                    <CustomTextField
                      fullWidth
                      label=''
                      value={columnName}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <CustomTextField
                      fullWidth
                      select
                      // defaultValue={
                      //   fieldsToRender.includes(columnName) 
                      //     ? columnName 
                      //     : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
                      //       ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
                      //       : 'select'
                      // }
                      value={selectedValues[columnName] || getDefaultValues()[columnName]}
                      label=''
                      onChange={handleSelectChange(columnName)} 
                      error={!!errorState[columnName]} // Apply error if duplicate is detected
                      helperText={errorState[columnName]} // Show helper text if error exists
                      disabled={mappingState[columnName]?.confirmed || mappingState[columnName]?.ignored}
                      SelectProps={{                       // ← note this
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP, // cap at 10 items
                            },
                          },
                        },
                      }}
                    >
                      <ListSubheader>Mandatory Fields</ListSubheader>
                      <MenuItem value='select' disabled>Select</MenuItem>
                      {predefinedFields.map((field, index) => (
                        <MenuItem key={index} value={field}>
                          {field}
                        </MenuItem>
                      ))}
                      <ListSubheader>Optional Fields</ListSubheader>
                      {additionalFields.map((field, index) => (
                        <MenuItem key={index} value={field}>
                          {field}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {mappingState[columnName]?.confirmed ? (
                      <Box sx={{ display: 'flex' }}>
                        <Icon>
                          <CheckCircleIcon sx={{ color: '#1FC16B', height: '17px', width: '17px', my: 'auto', mr: 2 }} />
                        </Icon>
                        <Typography sx={{ fontWeight: 'bold', color: 'success', my: 'auto', mr: 4 }}>Mapping Confirmed</Typography>
                        <Button variant='contained' color='main' onClick={() => handleEditClick(columnName)}>
                          Edit
                        </Button>
                      </Box>
                    ) : mappingState[columnName]?.ignored ? (
                      <Box sx={{ display: 'flex' }}>
                        <Typography sx={{ fontWeight: 'bold', my: 'auto', mr: 4 }}>Ignored</Typography>
                        <Button variant='contained' color='main' onClick={() => handleEditClick(columnName)}>
                          Edit
                        </Button>
                      </Box>
                    ) : (
                      <>
                        <Button
                          variant='contained'
                          sx={{ mr: 4, mb: 2 }}
                          color='main'
                          onClick={() => handleConfirmClick(columnName)}
                          disabled={isConfirmDisabled(columnName)} // Disable based on conditions
                        >
                          Confirm mapping
                        </Button>
                        <Button
                          variant='outlined'
                          color='primary'
                          sx={{ mb: 2 }}
                          onClick={() => handleIgnoreClick(columnName)}
                        >
                          Ignore this column
                        </Button>
                      </>
                    )}
                  </Grid>
                </Fragment>
              ))}
            </Grid>
          </Fragment>

        )
      case 1:
        return (
          <Fragment>          
          <Grid item xs={12} sm={12}>
            <ToggleButtonGroup
              exclusive
              value={alignment}
              onChange={handleAlignment}
              aria-label='text alignment'
              sx={{
                backgroundColor: '#F5F7FA',
                borderRadius: 2,
                p: 2,
                '& .MuiToggleButtonGroup-grouped': {
                  margin: '0',
                  border: 'none',
                  borderRadius: 1,
                  '&:not(:first-of-type)': {
                    borderRadius: '4px !important'
                  }
                }
              }}
            >
              <ToggleButton 
                value='all' 
                aria-label='left aligned'
                sx={{
                  px: 8,
                  '&.Mui-selected': {
                    backgroundColor: '#fff',
                    color: 'white !important',
                    '&:hover': {
                      backgroundColor: '#fff !important',
                    }
                  },
                  '&:not(.Mui-selected)': {
                    color: '#6B7280',
                  }
                }}
              >
                <Typography variant='body1' 
                  sx={{ 
                    textTransform: 'lowercase',
                    '&::first-letter': {
                      textTransform: 'uppercase'
                    }
                  }}
                >
                  All {allRows.length}
                </Typography>
              </ToggleButton>
              <ToggleButton 
                value='valid' 
                aria-label='left aligned'
                sx={{
                  px: 8,
                  '&.Mui-selected': {
                    backgroundColor: '#fff',
                    color: 'white !important',
                    '&:hover': {
                      backgroundColor: '#fff !important',
                    }
                  },
                  '&:not(.Mui-selected)': {
                    color: '#6B7280',
                  }
                }}
              >
                <Typography variant='body1' 
                  sx={{ 
                    textTransform: 'lowercase',
                    '&::first-letter': {
                      textTransform: 'uppercase'
                    }
                  }}
                >
                  Valid {validRows.length}
                </Typography>
              </ToggleButton>
              <ToggleButton 
                value='invalid' 
                aria-label='left aligned'
                sx={{
                  px: 8,
                  '&.Mui-selected': {
                    backgroundColor: '#fff',
                    color: 'white !important',
                    '&:hover': {
                      backgroundColor: '#fff !important',
                    }
                  },
                  '&:not(.Mui-selected)': {
                    color: '#6B7280',
                  }
                }}
              >
                <Typography variant='body1' 
                  sx={{ 
                    textTransform: 'lowercase',
                    '&::first-letter': {
                      textTransform: 'uppercase'
                    },
                    color:'#D73838'
                  }}
                >
                  Invalid {invalidRows.length}
                </Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid item xs={12} sm={12}>
            <DataGridPro
              autoHeight
              pagination
              rows={displayRows}
              rowCount={displayRows.length}
              columns={columns}
              getRowId={(row) => row.id}              
              sortingMode="server"
              paginationMode="server"
              pageSizeOptions={[rows.length, 25, 50]}
              paginationModel={paginationModel}
              onSortModelChange={handleSortModel}
              onPaginationModelChange={setPaginationModel}
              editMode="cell"
              // onCellEditCommit={handleEditCellChangeCommitted}
              slots={{ toolbar: ServerSideToolbar }}
              slotProps={{
                baseButton: {
                  size: 'medium',
                  variant: 'tonal',
                },
                toolbar: {
                  value: searchValue,
                  clearSearch: () => handleSearch(''),
                  onChange: (event) => handleSearch(event.target.value),
                  valueExists: searchValue !== '',
                },
              }}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  textTransform: 'none', // This will disable the capitalization
                }
              }}
            />
          </Grid>
        </Fragment>
        )
      default:
        return 'Unknown Step'
    }
  }

  const renderContent = () => {
      return (
        <>
        {message && (
          <Box mb={2} textAlign="center">
            <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
              {message.split('\n').map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </Typography>
          </Box>
        )}
        <form onSubmit={e => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        {getStepContent(activeStep)}
        <Grid item xs={12} sx={{ position: 'fixed', bottom: 0, right: 0, width: '100vw', display: 'flex', justifyContent: 'flex-end', py: 4, pr: 10, backgroundColor: 'white', boxShadow: '0 -2px 5px rgba(0,0,0,0.1)' }}>        
          <Button variant='tonal' color='secondary'  onClick={handleBack} sx={{ mr: 4 }}
          // disabled={activeStep === 0}
          >
            Back
          </Button>              
          <Button variant='contained' color='main' onClick={handleNext}  disabled={loading} >
          {activeStep === steps.length - 1 ? 'Complete Import' : 'Continue'}
          </Button>
        </Grid>
    </form>
    </>
      )
  }

  return (
    <BlankLayout>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '92vh' }}>
          <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <CardHeader
              title={
                 <Box sx={{ display: 'flex', flexDirection: smallScreen ? 'column' : 'row', gap: 4 }}>
          <Box>
            <img src={XLSX_Placeholder} />
          </Box>
          <Box>
            <Typography variant='h6'>Import data to Employees</Typography>
            <Typography variant='body1' color='text.secondary'>
              Employee data.csv
            </Typography>
                  </Box>
                </Box>
              }
              action={
                <Box sx={{ display: 'flex', alignItems: 'center', height: '100% !important', py: 3, }}>
                  <StepperWrapper>
      <Stepper
        activeStep={activeStep}
        connector={
          !smallScreen ? (
            <Icon icon={'tabler:chevron-right'} />
          ) : null
        }
      >
        <Step>
          <StepLabel StepIconComponent={StepperCustomDot}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: 'success.main' }}>
              <Icon icon='tabler:circle-check-filled' />
              <Typography color='success.main'>Upload</Typography>
            </Box>
          </StepLabel>
        </Step>
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepperCustomDot}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  color: index >= activeStep ? 'text.primary' : 'success.main'
                }}
              >
                {index < activeStep && <Icon icon='tabler:circle-check-filled' />}
                <Typography color={index >= activeStep ? 'text.primary' : 'success.main'}>
                  {step.title}
                </Typography>
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </StepperWrapper>
                </Box>
              }
            />
            <Divider />
            <CardContent sx={{ flexGrow: 1, overflowY: 'auto' }}>
              {renderContent()}
            </CardContent>
          </Card>
        </Box>

        {/* Error List Dialog */}      
        <Dialog
          fullWidth
          maxWidth="md"
          open={openErrorListDlg}
          onClose={handleCloseErrorListDlg}
          aria-labelledby="form-dialog-title"
          sx={{
            "& .MuiDialog-paper": {
              maxWidth: '650px', // Custom maxWidth between sm and md
              width: '100%', // Ensures it’s responsive within the set max width
            },
          }}
        >
          <DialogTitle>
            <Typography variant="h4" fontWeight='bold'>Save Unsuccessful</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Typography variant="button">The following employees will be skipped due to the reasons listed below.</Typography>
              </Grid>
              <Grid item xs={12}>
                <DataGridPro
                  autoHeight              
                  rows={errorMessages}
                  getRowId={(row) => row.id}
                  columns={errorColumns}           
                  sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                      textTransform: "none",
                      fontWeight: 'bold'
                    },
                    maxWidth: '600px'
                  }}
                />
              </Grid>
            </Grid>     
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "flex-end" }}
            className="dialog-actions-dense"
          >
            <Button variant="contained" color="main" onClick={handleCloseErrorListDlg}>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        {/* Success List Dialog */}      
        <Dialog
          fullWidth={true}
          maxWidth="xs"
          open={openSuccessListDlg}
          onClose={handleCloseSuccessListDlg}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <Typography variant="h4" fontWeight='bold'>Employee Import Success</Typography>
          </DialogTitle>
          <DialogContent>
            <Fragment>          
              {successMessages}
            </Fragment>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "flex-end" }}
            className="dialog-actions-dense"
          >
            <Button variant="contained" color="main" onClick={handleCloseSuccessListDlg}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </BlankLayout>
  )
}

export default StepEmployeeUploadFile